module.exports = __webpack_public_path__ + "static/cta-dont-f146e283bd859b0b4fb26cc41967bf4e.png";